import React from "react";

const DivComponent = React.forwardRef(({ children, marginBottom }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom,
      }}
    >
      {children}
    </div>
  );
});

export default DivComponent;
